module.exports = __webpack_public_path__ + "img/kalis_login_image.5f4768b2.png";